import React, { Component, useState, useEffect, useContext } from "react";
import {
  Card,
  Col,
  OverlayTrigger,
  Row,
  Tooltip,
  Table,
} from "react-bootstrap";
import { AiFillDiff } from "react-icons/ai";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { AES, enc } from "crypto-js";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { API_URL } from '../config';
import "datatables.net-responsive-dt";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useNavigate } from "react-router-dom";
import { TokenContext } from "../AuthProvider";
import $ from "jquery";
import axios from "axios";
import { BsFillEnvelopeFill } from "react-icons/bs";
import { FaPencilAlt, FaTrashAlt, FaPlus } from "react-icons/fa";
// import { decryptedAccessToken, encryptedAccessToken } from "../../Token";
import Header from '../Header'
import Footer from '../Footer'
const AccountsList = () => {
  const secret_key = "4d3a23fba54bbef1e14dd44ba9591612";
  const encryptedAccessToken = localStorage.getItem("access_token");
  const decryptedAccessToken = encryptedAccessToken
    ? AES.decrypt(encryptedAccessToken, secret_key).toString(enc.Utf8)
    : null;
  const navigate = useNavigate();
const [loading, setLoading] = useState(false);
  const [formData, setFromdata] = useState({

    account_record: "",

  });

console.log(formData)
  const handleChange = (e) => {

    setFromdata({ ...formData, [e.target.name]: e.target.value });

  };

  const handleSubmit = (event) => {

    event.preventDefault();


    const encryptedAccessToken = localStorage.getItem('access_token');
    const secret_key = '4d3a23fba54bbef1e14dd44ba9591612';
    if (encryptedAccessToken) {
      const decryptedAccessToken = AES.decrypt(encryptedAccessToken, secret_key).toString(enc.Utf8);

    fetch(API_URL+'add/record', {
              method: "POST",
              body: JSON.stringify(formData),
              headers: { Authorization: `Bearer ${decryptedAccessToken}`,
              'Content-Type': 'application/json' },
            })
              .then((response) => response.json())

              .then((response) => {

                  console.log(response)
                  console.log(response.status)
                if (response.message === "record addedd successfully") {
                                  const account_record_new = response.account_type;

                                  navigate("/tcf/add-tcf", {

                                    state: { account_record: account_record_new },

                                  });

                                }
              })
            }

    };


  const body=$(window).height()
  const header=$("#header").height()
  const nav=$(".navbar").height()
  const footer=$(".footer").height()
  const total_height=header+nav+footer;
  const window_height=body-total_height;
  console.log(total_height)
  console.log(body)
  $(".addAccount").css({"min-height":(window_height)+"px"})
  const userRole = localStorage.getItem("role");
  console.log(userRole);
  const { username ,token} = useContext(TokenContext);
  const [datas, setDatas] = useState([]);


  useEffect(() => {

    fetchData();
  }, [decryptedAccessToken]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_URL+'get/all/tcf', {
        headers: { Authorization: `Bearer ${decryptedAccessToken}` },        }
      );
      const data = response.data.tcf;
      console.log(data)
      setDatas(data);
      setLoading(false);
      $(document).ready(function(){
        setTimeout(()=>{
          $('#tables').DataTable();
        },5)
      })
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <>
    <Header/>
    <div className="contactAccount">
      <div className="page-header" id='add-account'>
    <div>
      <h2 className="main-content-title tx-24 mg-b-5">Accounts </h2>
      <ol className="breadcrumb">
        <li className="breadcrumb-item active" aria-current="page">Dashboard / Accounts</li>
      </ol>
    </div>
    <div className="d-flex">
      <div className="justify-content-center">
        {/* <button type="button" className="btn btn-primary my-2 btn-icon-text"> */}
          {/* <Link to='/accounts/add-record'> <i className="fe fe-download-cloud me-2"></i><FaPlus/> Add Account</Link> */}
          <Popup trigger={<button className="button add-accountrecord"> <FaPlus/> Add TCF </button>} modal>

       <form onSubmit={handleSubmit} className="add-accounts">
        <div className='form-group'>
        <label>TCF Record Type</label><br/>
        <select name='account_record' className='form-control' onChange={handleChange} value={formData.account_record}>
          <option >--Select TCF Record Type--</option>
          <option value='Buyer - Spot'>Buyer - Spot</option>
          <option value='Buyer - Long Term'>Buyer - Long Term</option>
          </select>
          </div>
          <input type='submit' className="btn btn-primary " value='Submit'/>

          </form>
  </Popup>
        {/* </button> */}
      </div>
    </div>
  </div>
  <div class='tasks'>
  {loading ? <p id='loading'>Loading Data..</p>
  :<table id='tables'>
    <thead>
             <tr>
      <th>TCF No</th>
      <th>Company</th>
      <th>Opportunity</th>
      <th>Quote</th>
      <th>Record Type</th>
      <th>Currency</th>
      <th>Purchase Confirmation Date</th>
      <th>Actions</th>
    </tr>
    </thead>
    <tbody>
      <React.Fragment>
      {datas.length > 0 ? (
  datas.map((x,i) => (
                     <tr key={i}>
      <td><Link to={"/tcf/tcf-details/"+x.id }>{x.tcf_no}</Link></td>
      <td>{x.company}</td>
      <td>{x.opportunity}</td>
      <td>{x.quote}</td>
      <td>{x.record_type}</td>
      <td>{x.currency}</td>
      <td>{x.purchase_confirmation_date}</td>
      <td><Link to={"/tcf/edit-tcf/"+x.id }><FaPencilAlt/> </Link><FaTrashAlt/><Link to={"/tcf/tcf-details/"+x.id }><AiFillDiff/></Link></td>
    </tr>
  ))
) : (
  <tr>
    <td colSpan="6">No data available</td>
  </tr>
)}

      </React.Fragment>


    </tbody>
    </table>
  }
    </div> </div>
    <Footer/>
    </>
  );
};

export default AccountsList;